/**
 * Sky High — Need Help FAB only (Shopify Inbox).
 *
 * REWARDS: stock Smile only (native launcher + panel).
 * Custom Rewards FAB / shell / intercept / dock was removed 2026-07-12
 * until rebuilt under a deliberate plan (see REWARDS-WIDGET-PLAN.md).
 *
 * Product pages: icon-only + dock above sticky ATC (quiet chrome).
 * All other pages: full labeled pill (unchanged UX).
 */
(function () {
  'use strict';

  var CHAT_VARS = {
    '--shopify-chat-bg-color': '#162530',
    '--shopify-chat-text-color': '#e8f1f6',
    '--shopify-chat-accent-bg-color': '#b4ff87',
    '--shopify-chat-accent-text-color': '#0b1216',
    '--shopify-chat-border-radius': '16px',
    '--shopify-chat-activator-offset': '18px',
  };

  var helpFab = null;
  var stickyWatchBound = false;
  var positionRaf = 0;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyChatVars() {
    try {
      var root = document.documentElement;
      Object.keys(CHAT_VARS).forEach(function (k) {
        root.style.setProperty(k, CHAT_VARS[k]);
      });
    } catch (e) {}
  }

  function isProductPage() {
    return !!(document.body && document.body.classList.contains('template-product'));
  }

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  function stickyAtcActive() {
    return document.documentElement.classList.contains('rework-sticky-atc-active');
  }

  function measureStickyAtcHeight() {
    var bar = document.getElementById('ReworkStickyAtc');
    if (!bar || !bar.classList.contains('rework-sticky-atc--in')) return 0;
    try {
      if (window.getComputedStyle(bar).display === 'none') return 0;
    } catch (e) {}
    var h = bar.getBoundingClientRect().height;
    return h > 0 ? h : 0;
  }

  function findChatHost() {
    return (
      document.querySelector('shopify-agent') ||
      document.querySelector('shopify-chat') ||
      document.querySelector('#ShopifyChat') ||
      document.querySelector('#shopify-chat') ||
      document.querySelector('[id*="ShopifyChat"]') ||
      document.querySelector('#chat-button-container') ||
      document.querySelector('[class*="shopify-chat"]')
    );
  }

  var CHAT_HOST_SEL =
    'shopify-agent, shopify-chat, #ShopifyChat, #shopify-chat, [id*="ShopifyChat"], #chat-button-container, #dummy-chat-button-iframe, iframe[title*="Shopify Chat"], iframe[title*="Need help"], iframe[title*="Need Help"]';

  function isChatHostOpen(host) {
    if (!host) return false;
    try {
      if (host.open === true) return true;
    } catch (e) {}
    try {
      if (host.hasAttribute('open') || host.hasAttribute('is-open')) return true;
    } catch (e2) {}
    return !!(host.classList && host.classList.contains('rework-chat-panel-open'));
  }

  function softHideNativeChatLauncher() {
    try {
      document.documentElement.classList.add('rework-hide-native-chat');
    } catch (e) {}
    try {
      document.querySelectorAll(CHAT_HOST_SEL).forEach(function (host) {
        if (isChatHostOpen(host)) return;
        if (host.classList && host.classList.contains('rework-chat-panel-open')) return;
        try {
          host.style.setProperty('display', 'none', 'important');
          host.style.setProperty('opacity', '0', 'important');
          host.style.setProperty('visibility', 'hidden', 'important');
          host.style.setProperty('pointer-events', 'none', 'important');
        } catch (e1) {}
      });
    } catch (e2) {}
  }

  function restoreHostForOpen(host) {
    if (!host) return;
    try {
      host.style.removeProperty('display');
      host.style.removeProperty('opacity');
      host.style.removeProperty('visibility');
      host.style.removeProperty('pointer-events');
    } catch (e) {}
  }

  var chatWatchTimer = null;

  function watchChatUntilClosed(host) {
    if (!host) return;
    if (chatWatchTimer) {
      clearInterval(chatWatchTimer);
      chatWatchTimer = null;
    }
    var checks = 0;
    var sawOpen = false;
    chatWatchTimer = setInterval(function () {
      checks += 1;
      try {
        var open = false;
        try {
          open = host.open === true;
        } catch (e) {
          open = host.hasAttribute('open') || host.hasAttribute('is-open');
        }
        if (open) {
          sawOpen = true;
          host.classList.add('rework-chat-panel-open');
          restoreHostForOpen(host);
        } else if (sawOpen || checks > 4) {
          host.classList.remove('rework-chat-panel-open');
          host.classList.remove('rework-chat-click-target');
          softHideNativeChatLauncher();
          clearInterval(chatWatchTimer);
          chatWatchTimer = null;
        }
      } catch (e2) {}
      if (checks > 120) {
        clearInterval(chatWatchTimer);
        chatWatchTimer = null;
      }
    }, 300);
  }

  function openChat() {
    var host = findChatHost();
    if (!host) return false;
    if (isChatHostOpen(host)) {
      host.classList.add('rework-chat-panel-open');
      restoreHostForOpen(host);
      watchChatUntilClosed(host);
      return true;
    }
    try {
      host.classList.add('rework-chat-panel-open');
      restoreHostForOpen(host);
      if (typeof host.show === 'function') {
        host.show();
        watchChatUntilClosed(host);
        return true;
      }
      if ('open' in host) {
        host.open = true;
        watchChatUntilClosed(host);
        return true;
      }
      if (typeof host.setAttribute === 'function') {
        host.setAttribute('open', '');
        watchChatUntilClosed(host);
        return true;
      }
    } catch (e) {}
    try {
      if (host.shadowRoot) {
        var toggle =
          host.shadowRoot.querySelector('.chat-toggle') ||
          host.shadowRoot.querySelector('button[class*="toggle"]') ||
          host.shadowRoot.querySelector('button');
        if (toggle) {
          host.classList.add('rework-chat-panel-open');
          restoreHostForOpen(host);
          try {
            toggle.click();
          } catch (e2) {
            toggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          }
          watchChatUntilClosed(host);
          return true;
        }
      }
    } catch (e3) {}
    host.classList.remove('rework-chat-panel-open');
    softHideNativeChatLauncher();
    return false;
  }

  function buildHelpFab() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'ReworkHelpFab';
    btn.className = 'rework-smile-fab rework-help-fab';
    btn.setAttribute('aria-label', 'Need help — open chat');
    btn.innerHTML =
      '<span class="rework-smile-fab__aurora" aria-hidden="true"></span>' +
      '<span class="rework-smile-fab__core">' +
      '<span class="rework-smile-fab__icon" aria-hidden="true">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M21 12a8.5 8.5 0 0 1-8.5 8.5c-1.3 0-2.5-.3-3.6-.8L3 21l1.4-4.2A8.4 8.4 0 0 1 3.5 12 8.5 8.5 0 1 1 21 12Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
      '<path d="M8.5 12h.01M12 12h.01M15.5 12h.01" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>' +
      '</svg></span>' +
      '<span class="rework-smile-fab__label">Need help</span>' +
      '<span class="rework-smile-fab__dot" aria-hidden="true"></span></span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openChat();
    });
    document.body.appendChild(btn);
    return btn;
  }

  function ensureHelpFab() {
    if (!document.body) return;
    if (!helpFab || !document.body.contains(helpFab)) {
      helpFab = buildHelpFab();
    }
  }

  /**
   * PDP: quiet icon. Sticky ATC on: dock just above the bar (measured).
   * Non-product: leave full labeled pill; only set right/zIndex so CSS owns bottom.
   */
  function applyHelpFabMode() {
    ensureHelpFab();
    if (!helpFab) return;

    var pdp = isProductPage();
    var docked = pdp && isMobile() && stickyAtcActive();

    helpFab.classList.toggle('rework-help-fab--icon', pdp);
    helpFab.classList.toggle('rework-help-fab--docked', docked);
  }

  function positionHelpFab() {
    ensureHelpFab();
    if (!helpFab) return;

    applyHelpFabMode();

    var mobile = isMobile();
    helpFab.style.right = mobile ? '1rem' : '1.25rem';
    helpFab.style.left = 'auto';
    helpFab.style.top = 'auto';
    helpFab.style.zIndex = '9999';

    // Product + sticky ATC: measure bar so icon sits tight above it (not mid-screen).
    if (isProductPage() && isMobile() && stickyAtcActive()) {
      var h = measureStickyAtcHeight();
      if (h > 0) {
        // 10px gap above sticky bar
        helpFab.style.setProperty('bottom', Math.round(h + 10) + 'px', 'important');
      } else {
        // Class active but bar not painted yet — safe fallback matching CSS
        helpFab.style.setProperty(
          'bottom',
          'calc(4.6rem + env(safe-area-inset-bottom, 0px))',
          'important'
        );
      }
      return;
    }

    // Default: clear JS bottom so stylesheet controls (and sticky !important rule can rest).
    try {
      helpFab.style.removeProperty('bottom');
    } catch (e) {
      helpFab.style.bottom = '';
    }
  }

  function schedulePositionHelpFab() {
    if (positionRaf) {
      try {
        cancelAnimationFrame(positionRaf);
      } catch (e) {}
    }
    positionRaf = requestAnimationFrame(function () {
      positionRaf = 0;
      positionHelpFab();
    });
  }

  function bindStickyAtcWatch() {
    if (stickyWatchBound || !isProductPage()) return;
    stickyWatchBound = true;

    try {
      var mo = new MutationObserver(function () {
        schedulePositionHelpFab();
      });
      mo.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    } catch (e) {}

    // Sticky bar may mount after us; remeasure when it appears / resizes.
    try {
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          schedulePositionHelpFab();
        });
        var attachRo = function () {
          var bar = document.getElementById('ReworkStickyAtc');
          if (bar) {
            try {
              ro.observe(bar);
            } catch (e2) {}
            return true;
          }
          return false;
        };
        if (!attachRo()) {
          var tries = 0;
          var t = setInterval(function () {
            tries += 1;
            if (attachRo() || tries > 40) clearInterval(t);
          }, 250);
        }
      }
    } catch (e3) {}
  }

  function revealHelpFab() {
    ensureHelpFab();
    requestAnimationFrame(function () {
      if (helpFab) helpFab.classList.add('rework-smile-fab--in');
    });
    softHideNativeChatLauncher();
    positionHelpFab();
  }

  function boot() {
    applyChatVars();
    softHideNativeChatLauncher();
    ensureHelpFab();
    positionHelpFab();
    bindStickyAtcWatch();
    setTimeout(revealHelpFab, reduceMotion ? 100 : 800);
    [600, 1500, 3000, 6000, 10000].forEach(function (ms) {
      setTimeout(function () {
        softHideNativeChatLauncher();
        positionHelpFab();
      }, ms);
    });
  }

  try {
    document.documentElement.classList.add('rework-hide-native-chat');
    softHideNativeChatLauncher();
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    softHideNativeChatLauncher();
    positionHelpFab();
    bindStickyAtcWatch();
  });

  window.addEventListener(
    'resize',
    function () {
      schedulePositionHelpFab();
    },
    { passive: true }
  );

  // Sticky ATC toggles class; also re-check on orientation / visual viewport (iOS).
  try {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedulePositionHelpFab, { passive: true });
    }
  } catch (e4) {}
})();
